export const seasonOfficialsExportFields = [
  {
    titleIntlKey: "seasonOfficials.columns.competition.title",
    fields: ["competitionName", "competitionId", "competitionExternalId"],
  },
  {
    titleIntlKey: "seasonOfficials.columns.season.title",
    fields: ["seasonName", "seasonId", "seasonExternalId"],
  },
  {
    titleIntlKey: "seasonOfficials.columns.person.title",
    fields: ["personName", "personId", "personExternalId", "personNameFullLatin", "personNationality", "personGender"],
  },
  {
    titleIntlKey: "seasonOfficials.columns.role.title",
    fields: ["roleId", "role", "bib", "dateFrom", "dateTo", "roleNumber", "roleSubType", "status"],
  },
  {
    titleIntlKey: "seasonOfficials.columns.entityGroup.title",
    fields: ["entityGroupName", "entityGroupId", "entityGroupExternalId"],
  },
  {
    titleIntlKey: "seasonOfficials.columns.entity.title",
    fields: ["entityName", "entityId", "entityExternalId"],
  },
];

export const defaultSeasonOfficialsExportFieldNames = [
  "personName",
  "personNationality",
  "personGender",
  "personId",
  "role",
  "roleId",
  "status",
];
